import React from "react";
import uRLs from "../utils/baseUtils";

const SubscriptionExpiredModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show"
        id="SubscriptionExpiredModal"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Subscription Expired</h5>

              {/* Close icon only when opened through Header */}
              {onClose && (
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onClose}
                ></button>
              )}
            </div>

            <div className="modal-body text-center py-4">
              <i
                className="bx bx-error-circle text-danger mb-3"
                style={{ fontSize: "55px" }}
              />

              <h5 className="mb-2">Your subscription has expired</h5>

              <p className="text-muted mb-4">
                Your main store subscription has expired. Please contact us to
                renew your subscription and continue using NegoBill.
              </p>

              <a
                href="https://heartinz.com/contact-1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Contact Us
              </a>
            </div>

            <div className="modal-footer justify-content-center">
              <span className="text-muted fs-7">
                Contact: {uRLs.CONTACT_PHONE}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionExpiredModal;
